module.exports = __webpack_public_path__ + "static/img/KM.1f1b84a9.svg";